import React from "react";
import { Box, TextField } from "@mui/material";
import { AddCircleOutline, RemoveCircleOutline } from "@mui/icons-material";
const AddTextField = ({
    onChange,
    textValue = [{ category: "", value: "" }],
    readonly,
}) => {
    const handleTextFieldChange = (index, field, newValue) => {
        const updatedArray = textValue.map((item, i) =>
            i === index ? { ...item, [field]: newValue } : item
        );

        if (onChange) {
            onChange(updatedArray);
        }
    };

    const handleAddTextField = () => {
        if (onChange) {
            onChange([...textValue, { category: "", value: "" }]);
        }
    };

    const handleRemoveTextField = (index) => {
        if (textValue.length > 1 && onChange) {
            const updatedArray = textValue.filter((_, i) => i !== index);
            onChange(updatedArray);
        }
    };

    return (
        <>
            {textValue?.map((row, index) => (
                <Box
                    key={index}
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        mb: 1,
                    }}
                >
                    <TextField
                        disabled={readonly}
                        placeholder="Category"
                        value={row.category}
                        onChange={(e) =>
                            handleTextFieldChange(index, "category", e.target.value)
                        }
                        sx={{
                            width: 140,
                            "& .MuiInputBase-input": {
                                px: 1,
                                py: 0.5,
                            },
                        }}
                    />
                    <TextField
                        disabled={readonly}
                        type="number"
                        placeholder="Value"
                        value={row.value}
                        onChange={(e) => {
                            const newValue = e.target.value;
                            if (newValue === "" || parseFloat(newValue) >= 0) {
                                handleTextFieldChange(index, "value", newValue);
                            }
                        }}
                        sx={{
                            width: 140,
                            "& .MuiInputBase-input": {
                                px: 1,
                                py: 0.5,
                            },
                        }}
                    />
                    {!readonly && (
                        <RemoveCircleOutline
                            onClick={() => handleRemoveTextField(index)}
                            sx={{
                                cursor: "pointer",
                                color: textValue.length > 1 ? "#858585" : "#ccc",
                                pointerEvents: textValue.length > 1 ? "auto" : "none",
                            }}
                        />
                    )}
                    {index === textValue.length - 1 && !readonly && (
                        <AddCircleOutline
                            onClick={handleAddTextField}
                            sx={{ cursor: "pointer", color: "#858585" }}
                        />
                    )}
                </Box>
            ))}
        </>
    );
};

export default AddTextField;
